import Close from '@mui/icons-material/Close';
import { useRef } from 'react';

import { trackEvents } from '@/utils/analytics';

import useStyles from './VideoOverlay.styles';

/**
 * @deprecated V2 component replace with components/VideoOverlay
 */
const VideoOverlay = ({
  src,
  onClose,
}: {
  src: string;
  onClose: () => void;
}) => {
  const { classes } = useStyles();
  const playerRef = useRef<HTMLIFrameElement>(null);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: Automated migration to Biome
    // biome-ignore lint/a11y/useKeyWithClickEvents: Automated migration to Biome
    <div
      className={classes.container}
      onClick={() => {
        trackEvents([
          {
            event: 'Watch the Video',
            video_action: 'Close',
            video_title: 'Why subscribe to solar?',
          },
        ]);
        onClose();
      }}
    >
      <iframe
        ref={playerRef}
        className={classes.videoIframe}
        src={src}
        frameBorder='0'
        allow='autoplay; fullscreen; picture-in-picture'
        title={'video overlay'}
      />
      {/** biome-ignore lint/a11y/useButtonType: Automated migration to Biome */}
      <button className={classes.closeButton} onClick={onClose}>
        <Close fill='black' fontSize='large' />
      </button>
    </div>
  );
};

export default VideoOverlay;
